import styles from './styles.module.css';

function Loading() {
  return (
    <div className={styles.loadingSpinnerEllipsis}>
      <div className={styles.ldio}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loading;